import React, { useState, useEffect } from "react";
import Event from "../components/Event";
import Grid from "@mui/material/Grid";

const EventsList = () => {
  const [events, setEvent] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch(
        `https://revived-witch-api.herokuapp.com/api/events`
      );
      res.json().then((res) => setEvent(res.events));
    };

    fetchData();
  }, []);
  return (
    <>
      <Grid container spacing={1} justify="center" style={{ margintTop: 25 }}>
        {events.map((event) => (
          <>
            <Grid item xs={12} md={4} display="grid">
              <Event key={event._id} data={event} />
            </Grid>
          </>
        ))}
      </Grid>
    </>
  );
};

export default EventsList;
